<template>
    <section>
        <div class=" flex">

            <div >
                <WelcomeBanner/>
            </div>
            <div class="w-4/5 lg:w-full">
                <div>
                    <TrackOrderHeader/>
                </div>

                <div class="w-2/5 m-auto mt-20 font-poppins lg:w-full text-xs">
                    <div class=" flex bg-gray-50 p-4">
                        <div>
                            <img src="../Images/Avatar.png" alt="img">
                        </div>
                        
                        <div class=" ml-3">
                            <div>
                                <div class=" flex">
                                    <div>
                                        <img src="../Images/avatar-name.png" alt="avatar">
                                    </div>
                                    <div class=" ml-2">
                                        <p>{{trackingDetails.customerName}}</p>
                                    </div>
                                </div>

                                <div class="flex mt-2">
                                    <div>
                                        <img src="../Images/dive-icon.png" alt="avatar">
                                    </div>
                                    <div>
                                        <p class=" ml-2">Sent a package</p>
                                    </div>
                                </div>

                                <div class="flex mt-2">
                                    <div>
                                        <img src="../Images/dive-icon2.png" alt="avatar">
                                    </div>
                                    <div class=" ml-2">
                                        <p>{{trackingDetails.items}}</p>
                                    </div>
                                </div>
                                <div class="flex mt-2">
                                    <div>
                                        <img src="../Images/dive-icon2.png" alt="avatar">
                                    </div>
                                    <div class=" ml-2">
                                        <p class="text-xs">{{trackingDetails.pickupAddress}} <span class="font-bold">to</span> {{deliveryAddress}}</p>
                                    </div>
                                </div>
                            </div>

                            <div class=" mt-1">
                                <p><span class=" text-gray-400">Lincense plate:</span> {{trackingDetails.riderLicenseNumber}}</p>
                                <p><span class=" text-gray-400">Rider Phone Number:</span> {{trackingDetails.riderPhoneNumber}}</p>

                            </div>
                        </div>
                    </div>

                    <div class=" mt-16 bg-gray-50 p-4">
                        <div> 
                            <div class=" font-semibold">
                                <p>Journey details</p>
                            </div>

                            <div class=" mt-8">
                                <div class=" flex">
                                    <div class=" relative">
                                        <img src="../Images/Oval1.png" alt="">
                                        <img class=" absolute left-5" src="../Images/Line1.png" alt="">
                                    </div>
                                    <div class=" ml-4">
                                        <p class=" text-blue-700">{{trackingDetails.customerName}}'s driver takes the trip</p>
                                        <div class=" flex mt-2">
                                            <div>
                                                <img src="../Images/calendar-date.png" alt="calendar">
                                            </div>
                                            <div class=" ml-2">
                                                <p>{{moment(trackingDetails.created_at).format('hh:mma')}}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class=" mt-8">
                            <div class=" flex">
                                <div class=" relative">
                                    <img src="../Images/Oval2.png" alt="icon">
                                    <img class=" absolute left-5" src="../Images/Line1.png" alt="blue-line">
                                </div>
                                <div class=" ml-4">
                                    <p class=" text-blue-700">Driver finished taking goods</p>
                                    <div class=" flex mt-2">
                                        <div>
                                            <img src="../Images/calendar-date.png" alt="calendar">
                                        </div>
                                        <div class=" ml-2">
                                            <p>{{moment(trackingDetails.updated_at).format('hh:mma')}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class=" mt-8">
                            <div class=" flex">
                                <div class=" relative">
                                    <img src="../Images/Oval3.png" alt="icon">
                                    <img class=" absolute left-5" src="../Images/grey-line.png" alt="grey-line">
                                </div>
                                <div class=" ml-4">
                                    <p class=" text-blue-700">On the journey</p>
                                    <div class=" flex mt-2">
                                        <div>
                                            <img src="../Images/calendar-date.png" alt="calendar">
                                        </div>
                                        <div class=" ml-2">
                                                <p>{{moment(trackingDetails.updated_at).format('hh:mma')}}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class=" mt-8">
                            <div class=" flex">
                                <div>
                                    <img src="../Images/Oval4.png" alt="">
                                </div>
                                <div class=" ml-4">
                                    <p v-if="status !== 'completed' " class="text-blue-600">Your Delivery is still in process</p>
                                    <p v-if="status === 'completed' " class=" text-green-400">Delivery completed</p>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            </div>

            
        </div>
    </section>
</template>

<script>
import TrackOrderHeader from './TrackOrderHeader.vue';
import WelcomeBanner from './WelcomeBanner.vue';
import axios from 'axios';
import moment from 'moment';
import {baseUrl} from '../../../Config';
const url = baseUrl;
export default {
    components: {
        TrackOrderHeader,
        WelcomeBanner
    },

    data() {
        return {
            trackingId : localStorage.getItem("trackingNumber"),
            trackingDetails: [],
            status: "",
            deliveryAddress: ""
        }
    },

     mounted() {
        this.checkTrackingNumber();
    },
    
    methods: {
        moment(date) {
            return moment(date);
        },

        checkTrackingNumber() {
                axios({
                    method: 'GET',
                    url: `${url}/v1/web/orders/${this.trackingId}`,
                    headers: {
                        'Content-type': 'application/json',
                        'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                    },
                })
                .then((response) => {
                    this.trackingDetails = response.data.data
                    if(response.data.data.status === "completed") {
                        this.status = "completed";
                    }
                    this.isLoading = false
                    this.$router.push('/trackinginfo')
                    this.deliveryAddress = this.trackingDetails.deliveryAddress[0]
                })
                .catch((error) => {
                    error.json
                })
            
        }
    }

    
}
</script>